import React, { useEffect, useState } from 'react';
import { RefreshCw, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PictureSelector } from './PictureSelector';
import { StoryPreview } from './StoryPreview';
import { SummaryPopup } from './SummaryPopup';
type CustomizeProps = {
  name?: string;
  topics?: string[];
  mood?: string;
  onUpdate?: (details: {
    storyText: string;
    artStyle?: string;
  }) => void;
};
export const Customize = ({
  name = '',
  topics = [],
  mood = '',
  onUpdate
}: CustomizeProps) => {
  const [showPromptHelp, setShowPromptHelp] = useState(false);
  const formatTopics = (topics: string[]) => {
    const lowercaseTopics = topics.map(topic => topic.toLowerCase());
    if (lowercaseTopics.length === 1) return lowercaseTopics[0];
    if (lowercaseTopics.length === 2) return `${lowercaseTopics[0]} and ${lowercaseTopics[1]}`;
    const lastTopic = lowercaseTopics[lowercaseTopics.length - 1];
    const otherTopics = lowercaseTopics.slice(0, -1).join(', ');
    return `${otherTopics}, and ${lastTopic}`;
  };
  const [storyText, setStoryText] = useState('');
  const [storyImages, setStoryImages] = useState<string[]>([]);
  const [showPreview, setShowPreview] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [selectedStyle, setSelectedStyle] = useState<string>('');
  const handleCreateStory = () => {
    if (storyText.trim()) {
      setShowPreview(true);
    }
  };
  const handleRandomPrompt = () => {
    const prompts = ['My 2 year old child loves to read boardbooks. Create another one for him', 'We are expecting a new baby. Write a story that will help my 2 year old understand what is going to happen', 'My 3 year old wants a story about a bunch of cars', 'My 4 year old does not want to go to bed. Write a story to make him sleepy!', 'Write a cute story about a little puppy who is excited for her first day of school. During the day, her new friends show her their favorite things — like what they love to do at recess and the best parts of the library. After school, they tell their family all about their fun day during dinner.'];
    setStoryText(prompts[Math.floor(Math.random() * prompts.length)]);
  };
  const handleImageSelect = (imageUrl: string) => {
    setStoryImages([...storyImages, imageUrl]);
  };
  const handleStyleSelect = (style: string) => {
    setSelectedStyle(style);
  };
  useEffect(() => {
    onUpdate?.({
      storyText,
      artStyle: selectedStyle
    });
  }, [storyText, selectedStyle, onUpdate]);
  return <div className="w-full max-w-3xl mx-auto space-y-4 mt-4 bg-transparent rounded-xl p-6 shadow-sm border border-[#E5C1A9]" data-id="element-339">
      {/* Section 1: Story Input */}
      <div data-id="element-340">
        <div className="min-h-[250px] bg-[#FFFBF6] rounded-xl border-2 border-dashed border-[#E5C1A9] flex flex-col items-center justify-center p-4 mb-4 relative" data-id="element-341">
          <textarea value={storyText} onChange={e => setStoryText(e.target.value)} placeholder="What do you want yor story to be about? For ideas, click for Suggestions below!" className="w-full h-48 bg-transparent border-none resize-none text-[#6B4B3E] placeholder-[#C4A497] focus:outline-none text-center z-10" data-id="element-342" />
          {/* Story Bunny Prompt Help Button */}
          <button onClick={() => setShowPromptHelp(true)} className="text-sm text-[#D4A088] hover:text-[#C28B73] transition-colors mt-2 z-10" data-id="element-343"></button>
        </div>
        <button onClick={handleRandomPrompt} data-id="element-344">Click for Suggestions</button>
      </div>
      {/* Section 2: Art Style */}
      <div className="relative z-10" data-id="element-345">
        <PictureSelector onSelect={handleImageSelect} onStyleSelect={handleStyleSelect} data-id="element-346" />
      </div>
      {showPreview && <StoryPreview story={storyText} onClose={() => setShowPreview(false)} onEdit={() => setShowPreview(false)} onCreate={() => {
      setShowPreview(false);
    }} data-id="element-347" />}
      {showSummary && <SummaryPopup name={name} topics={topics} mood={mood} storyText={storyText} artStyle={selectedStyle ? illustrationStyles.find(s => s.id === selectedStyle)?.label : undefined} onClose={() => setShowSummary(false)} onCreate={handleCreateStory} data-id="element-348" />}
    </div>;
};